export const PositionList = { LeftBottom: 'LB', RightTop: 'C1', RightMiddle: 'C2', RightBottom:'C3' } as const;
export type SpotPositionName = keyof typeof PositionList;
export type SpotPositionCode = (typeof PositionList)[keyof typeof PositionList];